import script from "./PromoGallery.vue?vue&type=script&setup=true&lang=js"
export * from "./PromoGallery.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__